import StudentDemoAccount from './StudentDemoAccount';

export default StudentDemoAccount;
